import React from 'react';

import { Team } from '@yandex-int/k-common';
import { Button, H1, SimpleText } from 'platform-components';
import PropTypes from 'prop-types';

import PageContentTitle from 'common.components/page-content-title/page-content-title';

import './course-journal__header.scss';

export const CourseJournalHeader = ({
    currentClass,
    showControls,
    onDownloadResult,
}: {
    currentClass: Team | null | undefined;
    showControls: boolean;
    onDownloadResult: () => void;
}) => {
    const { level, name } = currentClass || {};

    return (
        <div className="course-journal__header">
            <div className="course-journal__header-title">
                <PageContentTitle
                    mix="course-journal__header-title"
                    title={<H1 id="courseJournal.header" values={{ level, name }} />}
                />
                {showControls && (
                    <div className="course-journal__header-controls">
                        <Button accent={Button.ACCENT.NORMAL} onClick={onDownloadResult} view={Button.VIEW.CLEAR}>
                            <SimpleText id="common.downloadResult" />
                        </Button>
                    </div>
                )}
            </div>
        </div>
    );
};

CourseJournalHeader.propTypes = {
    currentClass: PropTypes.object.isRequired,
    onDownloadResult: PropTypes.func.isRequired,
    showControls: PropTypes.bool,
};
